import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tenantLifecycleRejectionReason } from '@app/shared/tenant-lifecycle/tenant-lifecycle';
import { TenantLifecycleService } from '@app/shared/tenant-lifecycle/tenant-lifecycle.service';
import { catchError } from 'rxjs/operators';

/**
 * Turns lifecycle rejections of the tenant API (403 with reason
 * `tenant_read_only` or `tenant_listening_disabled`) into a friendly toast
 * and locks the UI. The error is rethrown unchanged so callers still stop
 * their loading state.
 */
export const tenantLifecycleInterceptor: HttpInterceptorFn = (request, next) => {
  const lifecycle = inject(TenantLifecycleService);

  return next(request).pipe(
    catchError((error: unknown) => {
      const reason = tenantLifecycleRejectionReason(error);
      if (reason !== null) {
        lifecycle.handleRejection(reason);
      }
      throw error;
    }),
  );
};
